import { useCallback } from 'react';
import { sdk } from 'sdk';
import {
  V12CheckAppRequest,
  V12CheckAppResponse,
  V12InitAppResponse,
  V12PaymentOptions,
  V12PaymentRequest,
} from 'shared/types/payment/V12PaymentOption';

const useV12 = () => {
  const getPaymentOptions = useCallback(async () => {
    const response = await sdk.callAction<V12PaymentOptions>({
      actionName: 'v12/getPaymentOptions',
    });

    return response.isError ? [] : (response.data as V12PaymentOptions).FinanceProducts;
  }, []);

  const intiatePayment = useCallback(async (data: V12PaymentRequest) => {
    const response = await sdk.callAction<V12InitAppResponse>({
      actionName: 'v12/intiatePayment',
      payload: data,
    });

    if (response.isError) {
      throw new Error(response.error.message);
    }

    return response.data;
  }, []);

  const verifyAndPlaceV12Order = useCallback(async (data: V12CheckAppRequest) => {
    const response = await sdk.callAction<V12CheckAppResponse>({
      actionName: 'v12/verifyAndPlaceV12Order',
      payload: data,
    });

    if (response.isError) {
      throw new Error(response.error.message);
    }

    return response.data;
  }, []);

  const isV12PaymentEnabledForCart = useCallback(async () => {
    const response = await sdk.callAction<boolean>({
      actionName: 'v12/isV12PaymentEnabledForCart',
    });

    if (response.isError) {
      throw new Error(response.error.message);
    }

    return response.data;
  }, []);

  return { getPaymentOptions, intiatePayment, verifyAndPlaceV12Order, isV12PaymentEnabledForCart };
};

export default useV12;
